module.exports = __webpack_public_path__ + "d833ce36f5ff69a3b0e787844763218c.ttf";